import api from '../services/httpClient';

function isIOSDevice() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

/**
 * Validate access and open the gateway through the hub proxy.
 * On desktop, the blank tab is opened before the access check so popup blockers allow it.
 */
export async function connectToGateway(gateway, servicePath = '') {
  let newWindow = null;
  const isiOSDevice = isIOSDevice();

  try {
    if (!isiOSDevice) {
      newWindow = window.open('', '_blank');
      if (!newWindow) {
        return { ok: false, reason: 'popup_blocked' };
      }
      newWindow.document.write(
        '<html><head><title>Connecting...</title></head><body style="font-family: Arial; text-align: center; padding-top: 100px;"><h2>Connecting to gateway...</h2><p>Please wait...</p></body></html>'
      );
    }

    const response = await api.post('/v1/gateway/validate-access', {
      deviceToken: gateway.deviceToken,
    });

    if (response.data.authorized) {
      const proxyUrl = `/proxy/gateway/${gateway.id}${servicePath}`;
      if (isiOSDevice) {
        window.location.href = proxyUrl;
      } else {
        newWindow.location.href = proxyUrl;
      }
      return { ok: true };
    }

    if (newWindow && !newWindow.closed) {
      newWindow.close();
    }

    if (response.data.reason === 'subscription_required') {
      return { ok: false, reason: 'subscription_required' };
    }
    return { ok: false, reason: 'unauthorized' };
  } catch (error) {
    if (newWindow && !newWindow.closed) {
      newWindow.close();
    }
    return {
      ok: false,
      reason: 'error',
      message: error.response?.data?.error || error.message,
    };
  }
}

export function reportGatewayAccessFailure(result) {
  if (!result || result.ok || result.reason === 'subscription_required') {
    return;
  }
  if (result.reason === 'popup_blocked') {
    alert('Please allow popups for this site to connect to gateways');
    return;
  }
  if (result.reason === 'unauthorized') {
    alert('You are not authorized to access this gateway');
    return;
  }
  alert(`Failed to access gateway: ${result.message || 'Unknown error'}`);
}
